export enum BomPartType {
  COMPONENT = '__component__',
  DISCOUNT = '__discount__',
  ELEMENT = '__element__',
  PART = '__part__',
}

export enum BomLineType {
  BASE_CODE = 'baseCode',
  CONFIGURED = 'configured',
  DISCOUNT_CODE = 'discountCode',
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified',
  WILDCARD = 'wildcard',
}

export enum BomPartViewByType {
  ELEMENT = 'element',
  PART = 'part',
}
